import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  // .use(Backend)
  .init({
    debug: false,
    keySeparator: false,
    lng: 'en',
    fallbackLng: 'en',
    initImmediate: true,
    interpolation: {
      escapeValue: false
    },
    resources: {}
  });

export default i18n;
